export default "__VITE_ASSET__BXuM5UqP__"